import { render, staticRenderFns } from "./RichMenu.vue?vue&type=template&id=20ef53d1&"
import script from "./RichMenu.vue?vue&type=script&lang=js&"
export * from "./RichMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports